<template>
  <div class="box" id="main"></div>
</template>
<script>
import * as echarts from 'echarts/core';
import { LineChart } from 'echarts/charts';
import { TooltipComponent, GridComponent } from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';

echarts.use([LineChart, TooltipComponent, GridComponent, CanvasRenderer]);
export default {
  props: ['contentData'],
  watch: {
    contentData: {
      handler(v) {
        this.init();
      },
      deep: true
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.myChart = echarts.init(document.getElementById('main'));
      let data = this.contentData;

      const dateList = data.map(function (item) {
        return item[0];
      });
      const valueList = data.map(function (item) {
        return item[1];
      });

      let option = {
        // Make gradient line here
        grid: {
          top: '20px',
          left: '30px',
          right: '15px',
          bottom: '20px'
        },
        tooltip: {
          trigger: 'axis',
          textStyle: {
            color: '#fff'
          },
          backgroundColor: 'rgba(0,0,0,0.65)',
          borderColor: 'transparent',
          formatter:
            '{b}<br /><span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:#EBB436"></span>处方量:{c0}单'
        },
        xAxis: [
          {
            data: dateList,
            axisLine: {
              lineStyle: {
                color: '#F2F2F2'
              }
            },
            axisLabel: {
              color: '#707070'
            }
          }
        ],
        yAxis: [
          {
            splitLine: { show: false },
            axisLine: {
              show: true,
              lineStyle: {
                color: '#F2F2F2'
              }
            },
            axisLabel: {
              color: '#707070',
              align: 'left',
              margin: '30'
            }
          }
        ],
        series: [
          {
            type: 'line',
            showSymbol: false,
            data: valueList,
            lineStyle: {
              color: '#EBB436'
            },
            itemStyle: {
              borderColor: '#EBB436'
            }
          }
        ]
      };
      this.myChart.setOption(option);
    }
  }
};
</script>
<style lang="scss" scoped>
.box {
  height: 360px;
}
</style>
